<template>
    <main class="bg-embaixadores">
        <toaster/>
        <header>
            <img class="span" src="@/assets/img/logo_rede.svg" alt="">
        </header>
        <div class="form">
            <section>
                <h1>Você foi indicado no programa</h1>
                <img class="logo" src="@/assets/img/embaixadores_logo.png" alt="">
            </section>
            <article>
                <h4>
                    Para confirmar a indicação preencha os seus dados abaixo, em breve você receberá um whatsapp
                    para agendar sua visita na Rede!
                </h4>
            </article>

            <form @submit.prevent="enviarFormulario">
                <div class="row-inputs">
                    <div class="input-box largo">
                        <input
                            type="text"
                            placeholder=" "
                            required
                            v-model="nome"
                        >
                        <span class="floating-label">Nome Completo</span>
                    </div>
                    <div class="input-box curto">
                        <input
                            type="text"
                            placeholder=" "
                            v-model="cpf"
                            required
                            @input="mascaraCPF"
                        >
                        <span class="floating-label">CPF</span>
                    </div>
                </div>

                <div class="row-inputs ml-5">
                    <div class="input-box largo">
                        <input
                            type="email"
                            placeholder=" "
                            required
                            @change="validateEmail()"
                            v-model="email"
                        >
                        <span class="floating-label">Email</span>
                    </div>
                    <div class="input-box curto">
                        <input
                            type="tel"
                            placeholder=" "
                            v-model="telefone"
                            @input="mascaraTelefone"
                            required
                        >
                        <span class="floating-label">Telefone</span>
                    </div>
                </div>

                <div class="row-inputs margin-input">
                    <div class="input-box curto">
                        <select required v-model="course">
                            <option value="" disabled hidden></option>
                            <option value="2026">2026</option>
                            <option value="2027">2027</option>
                        </select>
                        <span class="floating-label">Período Letivo</span>
                    </div>
                    <div class="input-box largo">
                        <select required v-model="idUnidade">
                            <option value="" disabled hidden></option>
                            <option
                                v-for="unidade in unidadesOptions"
                                :key="unidade.value"
                                :value="unidade.value"
                            >
                                {{ unidade.label }}
                            </option>
                        </select>
                        <span class="floating-label">Unidade</span>
                    </div>
                </div>

                <div class="form-footer">
                    <label class="terms">
                        <input type="checkbox" v-model="aceiteTermos">
                        <p>
                            Li e aceito as <span> políticas de privacidade</span>
                        </p>
                    </label>
                    <button
                        type="submit"
                        class="btn-enviar"
                        :disabled="loading || !aceiteTermos"
                    >
                        {{ loading ? 'Enviando...' : 'Enviar' }}
                    </button>
                </div>

            </form>
        </div>
    </main>
</template>

<script>
import EmbaixadoresService from '@/services/embaixadores.service'
import UserService from '@/services/user.service'
import { createSelectOptions } from '@/services/utils.service'

export default {
    data() {
        return {
            nome: '',
            cpf: '',
            email: '',
            telefone: '',
            course: '',
            idUnidade: '',
            unidadesOptions: [],
            aceiteTermos: false,
            loading: false,
            successMessage: '',
            errorMessage: '',
            buyerId: null
        }
    },
    mounted() {
				// console.log("this.$route:", this.$route.query.cod_agente)
        this.buyerId = this.$route.query.cod_agente || null
        this.getUnidades()
    },
    methods: {
        getUnidades() {
            UserService.getUnidades().then(
                response => {
                    // console.log('getUnidades (Embaixadores):', response.data)
                    const unidades = response.data.filter(a => a.educacional && a.sigla != 'EAD')

                    this.unidadesOptions = createSelectOptions(
                        unidades,
                        'idUnidade',
                        'descricao'
                    )
                },
                error => {
                    console.error(error)
                    this.errorMessage = 'Não foi possível carregar as unidades. Tente novamente mais tarde.'
                }
            )
        },
        mascaraCPF() {
            let v = this.cpf.replace(/\D/g, '')

            if (v.length > 11) v = v.slice(0, 11)

            v = v.replace(/(\d{3})(\d)/, '$1.$2')
            v = v.replace(/(\d{3})(\d)/, '$1.$2')
            v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2')

            this.cpf = v
        },
        mascaraTelefone() {
            let v = this.telefone.replace(/\D/g, '')

            if (v.length > 11) v = v.slice(0, 11)

            if (v.length <= 10) {
                v = v.replace(/(\d{2})(\d)/, '($1) $2')
                v = v.replace(/(\d{4})(\d)/, '$1-$2')
            } else {
                v = v.replace(/(\d{2})(\d)/, '($1) $2')
                v = v.replace(/(\d{5})(\d)/, '$1-$2')
            }

            this.telefone = v
        },

        validateEmail () {
            if (typeof this.email !== 'string') return false;

            const value = this.email.trim().toLowerCase();

            const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)

            if ( !valid ) {
                this.email = ""
                window.toaster.emit('open', {
                    style: 'error',
                    message: 'Email inválido.',
                    floater: true
                })
            }
        },
        mostrarErroPadrao() {
            window.toaster.emit('open', {
                style: 'error',
                message: 'Ocorreu um erro inesperado. Entre em contato com a unidade para saber mais.',
                floater: true
            })
        },

        mostrarSucessoPadrao() {
            window.toaster.emit('open', {
            style: 'success',
            message: 'Inscrição realizada com sucesso.',
            floater: true
            })
        },


        async enviarFormulario() {
        if (!this.aceiteTermos) {
            this.mostrarErroPadrao()
            return
        }

        if (!this.idUnidade) {
            this.mostrarErroPadrao()
            return
        }

        this.loading = true

        try {
            const payload = {
                buyerId: this.buyerId,
                name: this.nome,
                cpf: this.cpf,
                phone: this.telefone,
                email: this.email,
                course: this.course,
                type: 'novo',
                idUnidade: this.idUnidade
            }

            const { data } = await EmbaixadoresService.postIndicacaoEmbaixadores(payload)

            if (data.success) {
                this.mostrarSucessoPadrao()
                this.nome = ''
                this.cpf = ''
                this.email = ''
                this.telefone = ''
                this.course = ''
                this.idUnidade = ''
                this.aceiteTermos = false
            } else {
                this.mostrarErroPadrao()
            }
        } catch (error) {
            console.error(error)
            this.mostrarErroPadrao()
        } finally {
            this.loading = false
        }
        }


    }
}
</script>


<style lang="scss" scoped>
    $amarelo-emb: #FAD24A;
    $azul-emb: #2C386F;
    $cinza-emb: #707070;
    $mg: 20px;

    main {
        * {
            font-family: "Poppins", sans-serif;
            box-sizing: border-box;
        }

        .span {
            width: 40%;
            padding: $mg;
            height: auto;
            
            @media (max-width: 768px) {
                width: 45%;
                display: flex;
                justify-content: center;
                margin: 0 auto;
                padding: 10px;
            }
        }
    }

    .bg-embaixadores {
        width: 100%;
        min-height: 100vh;
        background-image: url('@/assets/img/Embaixadores.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        justify-content: center;

        @media (max-width: 768px) {
            background-image: url('@/assets/img/Embaixadores_mobile.png');
            background-position: center 50px;
            background-size: 100% auto;
            background-color: $color-secondary;
            background-attachment: scroll; 
            flex-direction: column;
            align-items: flex-start; 
            justify-content: start;
        }

        header {
            width: 100%;
        }
				// >header {
        //     width: 100%;
        // }
        .form {
            width: 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            padding-bottom: 40px;

            article {
                display: flex;
                align-items: center;
                text-align: center;
                justify-content: center;
                color: $cinza-emb;
                width: 60%;
                margin-top: 10px;
                
                @media (max-width: 768px) {
                    width: 90%;
                    
                    h4 {
                        font-size: 15px;
                    }
                }
            }

            section {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                padding-top: $mg;

                h1 {
                    color: $azul-emb;
                    font-size: 1.5rem;
                    margin-bottom: 10px;
                    text-align: center;
                    
                    @media (max-width: 768px) {
                        font-size: 1.2rem;
                    }
                }
            }

            .logo {
                width: 60%;
                height: auto;
                
                @media (max-width: 768px) {
                    width: 80%;
                }
            }

            form {
                margin-top: 25px;
                width: 75%;
                display: flex;
                flex-direction: column;
                gap: 15px;

                @media (max-width: 768px) {
                    width: 85%;
                    gap: 10px;
                }

                .row-inputs {
                    display: flex;
                    gap: 15px;
                    width: 100%;

                    .largo { flex: 2; }
                    .curto { flex: 1; }

                    @media (max-width: 768px) {
                        flex-direction: column;
                        gap: 10px;
                        margin-left: 0 !important;
                        
                        .largo, .curto {
                            width: 100%;
                            flex: unset;
                        }
                    }
                }

                .margin-input {
                    margin-left: -$mg !important;
                    
                    @media (max-width: 768px) {
                        margin-left: 0 !important;
                    }
                }

                .ml-5 {
                    @media (max-width: 768px) {
                        margin-left: 0 !important;
                    }
                }

                .input-box {
                    position: relative;
                    height: 50px;
                    background: white;
                    border: 2px solid $azul-emb;
                    border-radius: 14px;
                    transition: .2s ease;

                    &:focus-within {
                        border-color: darken($azul-emb, 10%);
                        box-shadow: 0px 0px 0px 3px rgba(44, 56, 111, 0.15);
                    }

                    input, select {
                        width: 100%;
                        height: 100%;
                        background: transparent;
                        border: none;
                        outline: none;
                        padding: 0 20px 0 40%;
                        font-size: 14px;
                        color: $azul-emb;
                        font-weight: 600;
                        text-align: right;
                        text-overflow: ellipsis;
                        
                        &::placeholder {
                            color: transparent; 
                        }
                        
                        & {
                            appearance: none;
                            cursor: pointer;
                        }
                    }

                    .floating-label {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        pointer-events: none;
                        color: $amarelo-emb;
                        font-weight: 500;
                        font-size: 14px;
                        transition: all 0.3s ease;
                        white-space: nowrap;
                    }

                    input:focus ~ .floating-label,
                    input:not(:placeholder-shown) ~ .floating-label,
                    select:focus ~ .floating-label,
                    select:valid ~ .floating-label {
                        left: 20px;
                        transform: translate(0, -50%);
                        font-size: 12px;
                        font-weight: 700;
                    }
                }
                
                select {
                    background-repeat: no-repeat;
                    background-position: left 15px center; 
                    background-size: 14px;
                }

                .form-footer {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 5px;
                    padding: 0 5px;
                    gap: $mg;

                    @media (max-width: 768px) {
                        flex-direction: row;
                        justify-content: space-between;
                        gap: 10px;
                        margin-bottom: 20px;
                    }

                    .terms {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 8px;
                        color: $azul-emb;
                        font-size: 13px;
                        font-weight: 600;
                        cursor: pointer;
                        height: 2rem;

                        p {
                            margin: 0;
                            text-align: center;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            gap: 4px;
                        }
                        
                        @media (max-width: 768px) {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            text-align: center;
                            p {
                                text-align: center;
                                align-items: center;
                                justify-content: center;                                
                                font-size: 10px;
                            }
                        }

                        span {
                            text-decoration: underline;
                        }

                        input[type="checkbox"] {
                            appearance: none;
                            width: 16px;
                            height: 16px;
                            border: 2px solid $azul-emb;
                            border-radius: 4px;
                            cursor: pointer;
                            display: grid;
                            place-content: center;
                            flex-shrink: 0;

                            &:checked::before {
                                content: "";
                                width: 8px;
                                height: 8px;
                                background-color: $azul-emb;
                                border-radius: 2px;
                            }
                        }
                    }

                    .btn-enviar {
                        background-color: $azul-emb;
                        color: $amarelo-emb;
                        border: none;
                        padding: 10px 45px;
                        border-radius: 20px;
                        font-weight: 600;
                        font-size: 14px;
                        cursor: pointer;
                        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                        
                        &:hover {
                            background-color: lighten($azul-emb, 5%);
                        }

                        &:disabled {
                            opacity: 0.6;
                            cursor: not-allowed;
                        }
                    }
                }
            }
        }
    }
</style>
